import AddContentForm from 'components/Form/AddContent/AddContentForm';
import AddManyContentsForm from 'components/Form/AddManyContents/AddManyContentsForm';
import ChooseProject from 'components/Form/ChooseProject/ChooseProject';
import ForgotPasswordForm from 'components/Form/ForgotPassword/ForgotPasswordForm';
import LoginForm from 'components/Form/Login/LoginForm';
import ResetPasswordForm from 'components/Form/ResetPassword/ResetPasswordForm';
import Home from 'components/Home/Home';
import TranslationProgress from 'components/TranslationProgress/TranslationProgress';
import { RouterUrlEnum } from 'enums/routerUrl';
import { IRoute } from 'types/Router';

export const MainRoutes: IRoute[] = [
  {
    pathname: RouterUrlEnum.LOGIN,
    privateRoute: false,
    restricted: true,
    component: LoginForm,
  },
  {
    pathname: RouterUrlEnum.CHANGE_PASSWORD,
    privateRoute: false,
    restricted: true,
    component: ResetPasswordForm,
  },
  {
    pathname: RouterUrlEnum.FORGOT_PASSWORD,
    privateRoute: false,
    restricted: true,
    component: ForgotPasswordForm,
  },
  {
    pathname: RouterUrlEnum.HOME,
    privateRoute: true,
    component: Home,
  },
  {
    pathname: RouterUrlEnum.CHOOSE_PROJECT,
    privateRoute: true,
    restricted: true,
    component: ChooseProject,
  },
];

export const TrustedRoutes: IRoute[] = [
  {
    pathname: RouterUrlEnum.ADD_CONTENT,
    privateRoute: true,
    exact: true,
    iframe: true,
    component: AddContentForm,
  },
  {
    pathname: RouterUrlEnum.ADD_MANY_CONTENT,
    privateRoute: true,
    exact: true,
    component: AddManyContentsForm,
  },
  {
    pathname: RouterUrlEnum.TRANSLATION_PROGRESS,
    privateRoute: true,
    exact: true,
    component: TranslationProgress,
  },
];
